import React from "react";
import "./pchemical.css";
import bucket1 from "./image/Bucket-Elevator-Chain2.jpg";
import bucket2 from "./image/Bucket-Elevator-chain.jpg";
import bucket3 from "./image/Conveyor-chain3.jpg";

const Pchemical = () => {
  return (
    <div>
      <div className="chemicalp">
        <p className="p">Chemical And Fertilizer Industry</p>
        <div className="p2">
          {/* <p>Swajit Engineering Pvt.Ltd: &gt; Products &gt; Chemical And Fertilizer Industry</p> */}
        </div>
      </div>

      <div className="chemicall">
        <div className="unimg">
          <figure>
            <img src={bucket1} alt="Ash Chain" />
            <figcaption>Bucket Elevator Chain</figcaption>
          </figure>
        </div>

        <div className="chimg">
          <figure>
            <img src={bucket2} alt="Drag Chain" />
            <figcaption>Bucket Elevator Chain</figcaption>
          </figure>
        </div>

        <div className="chimg">
          <figure>
            <img src={bucket3} alt="Gate Chain" />
            <figcaption>Bucket Elevator Chain-G2 Attachment</figcaption>
          </figure>
        </div>
      </div>
    </div>
  );
};

export default Pchemical;
